<template>
  <div class="work-upload" v-loading.fullscreen.lock="fullscreenLoading">
    <Banner :competition="competition"></Banner>

    <div class="content">
      <div class="title">
        <img src="../../assets/saishianpai-title-icon.png" alt="" />
        <p class="tit">作品上传</p>
      </div>
      <div class="intro" v-if="intro">
        <p class="intro-p" v-html="intro"></p>
      </div>
      <div class="form">
        <el-form
          ref="uploadFormRef"
          :model="form"
          label-width="120px"
          size="medium"
        >
          <el-form-item
            v-if="workTypeOptions.length > 0"
            label="作品类型："
            prop="workType"
            :rules="{ required: true, message: '请选择作品类型' }"
          >
            <template v-if="code === 200004">
              <el-select
                v-model="form.workType"
                placeholder="请选择"
                style="width: 300px"
              >
                <el-option
                  v-for="item in workTypeOptions"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </template>
            <template v-else-if="code === 200003">
              <span>{{ selectedWorkTypeLabel || "未选择" }}</span>
            </template>
          </el-form-item>
          <el-form-item
            v-for="(workField, index) in workFieldList"
            :key="workField.id"
            :label="`${workField.title}：`"
            :prop="`file${index}`"
            :rules="{
              required: workField.isRequired === 1,
              message: `请上传${workField.title}`,
            }"
          >
            <div class="file-item" v-if="code === 200003">
              <span class="text-overflow" :title="workField.fileName">
                {{ workField.fileName ? workField.fileName : "未上传" }}
              </span>
              <a
                class="download-btn"
                v-if="workField.fileUrl"
                download
                :href="workField.fileUrl"
              >
                下载
              </a>
            </div>
            <template v-else-if="code === 200004">
              <el-upload
                action
                :limit="1"
                :show-file-list="false"
                :multiple="false"
                :disabled="workField.disabled"
                :accept="workField.accept"
                :before-upload="
                  (file) => onBeforeUpload(file, index, workField)
                "
              >
                <el-button
                  :loading="workField.loading"
                  :disabled="workField.disabled"
                  size="mini"
                >
                  上传
                </el-button>
              </el-upload>
              <!-- <p v-show="workField.loading">
                正在上传中，预计3-5分钟，请耐心等待，切勿关闭页面
              </p> -->
              <el-progress
                v-if="workField.progress"
                :percentage="workField.progress"
                text-color="#fff"
              />
              <p v-show="workField.fileName" class="text-overflow">
                {{ workField.fileName }}
                <i
                  class="el-icon-close close-btn"
                  style="cursor: pointer"
                  @click="onDelete(index, workField)"
                >
                </i>
              </p>
              <!-- 9对应所有类型文件 -->
              <p>
                {{
                  `${
                    !workField.typeList.includes(9)
                      ? genUploadType(workField.typeList).tip + "，"
                      : ""
                  }文件大小不可超过${workField.maxSize}mb`
                }}
              </p>
            </template>
          </el-form-item>
          <el-form-item v-if="code === 200004">
            <el-button type="primary" @click="onSave">提交作品信息</el-button>
            <p>信息一旦提交不可修改，请仔细核对</p>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner";
import {
  getWorkInfo,
  getCompetitionDetail,
  // uploadWork,
  saveWork,
  getToken,
  getDicts,
} from "@/api";
import request from "@/utils/request";

// const FileType = {
//   1: 'pdf',
//   2: 'jpg',
//   3: 'jpeg',
//   4: 'doc',
//   5: 'docx',
//   6: 'ppt',
//   7: 'pptx',
//   8: 'mp4',
//   9: '*',
// };

const fileTypeMap = new Map();
fileTypeMap.set(1, ".pdf");
fileTypeMap.set(2, ".jpg");
fileTypeMap.set(3, ".jpeg");
fileTypeMap.set(4, ".doc");
fileTypeMap.set(5, ".docx");
fileTypeMap.set(6, ".ppt");
fileTypeMap.set(7, ".pptx");
fileTypeMap.set(8, ".mp4");
fileTypeMap.set(9, ".*");

export default {
  name: "WorkUpload",
  components: { Banner },
  data() {
    return {
      intro: "",
      form: { workType: "" },
      workFieldList: [],
      workTypeDict: [],
      workTypeOptions: [],
      fullscreenLoading: false,
      competition: {},
      // 200003 上传过作品
      // 200004 未上传过作品，显示提交按钮
      // 500 错误响应，弹出提示即可  msg为红色警告，intro为蓝色说明区域文案
      code: undefined, // 区分状态
    };
  },
  computed: {
    competitionId({ $route }) {
      return $route.query.competitionId;
    },
    selectedWorkTypeLabel() {
      const found = this.workTypeDict.find(
        (item) => item.dictValue === this.form.workType
      );
      return found ? found.dictLabel : this.form.workType;
    },
  },
  created() {
    this.getWorkInfo();
    this.getCompetitionDetail();
    this.loadWorkTypeDict();
  },
  methods: {
    async loadWorkTypeDict() {
      try {
        const { data } = await getDicts("competition_work_type");
        this.workTypeDict = data || [];
      } catch (e) {
        this.workTypeDict = [];
      }
    },
    filterWorkTypeOptions(workTypeOptions) {
      // workTypeOptions 为这场比赛启用的 dict_value 列表
      if (!Array.isArray(workTypeOptions) || workTypeOptions.length === 0) {
        return [];
      }
      const dictMap = new Map(
        (this.workTypeDict || []).map((it) => [it.dictValue, it])
      );
      return workTypeOptions
        .map((val) => dictMap.get(val))
        .filter(Boolean);
    },
    genUploadType(types) {
      types = types || [];
      const res = [];
      if (types.length) {
        types.forEach((type) => {
          switch (type) {
            case 1:
              res.push(".pdf");
              return;
            case 2:
              res.push(".jpg");
              return;
            case 3:
              res.push(".jpeg");
              return;
            case 4:
              res.push(".doc");
              return;
            case 5:
              res.push(".docx");
              return;
            case 6:
              res.push(".ppt");
              return;
            case 7:
              res.push(".pptx");
              return;
            case 8:
              res.push(".mp4");
              return;
            case 9:
              res.push(".*");
              return;
          }
        });
      }

      return {
        tip: `请上传${res.join("、")}类型文件`,
        accept: res.indexOf(".*") > -1 ? "" : res.join(","),
      };
    },
    getWorkInfo() {
      getWorkInfo(this.competitionId)
        .then(({ code, data }) => {
          this.code = code;
          this.intro = data.intro;
          this.form.workType = data.workType || "";
          this.workTypeOptions = this.filterWorkTypeOptions(data.workTypeOptions);
          const workFieldList = (data.workFieldList || []).map((item) => ({
            disabled: false,
            progress: 0,
            accept: this.genUploadType(item.typeList).accept,
            loading: false,
            ...item,
          }));

          workFieldList.forEach((workField, index) => {
            this.$set(this.form, `file${index}`, "");
          });
          this.workFieldList = workFieldList;
        })
        .catch(({ data }) => {
          if (data?.data) {
            this.intro = data.data.intro;
          }
        });
    },

    onBeforeUpload(file, index, workField) {
      const fileName = file.name;
      const suffix = fileName.substr(fileName.lastIndexOf(".")).toLowerCase();
      let { typeList } = workField;
      typeList = [...typeList];
      typeList.forEach((item, index) => {
        typeList[index] = fileTypeMap.get(item);
      });

      if (!typeList.includes(".*") && !typeList.includes(suffix)) {
        this.$message.error(`请上传${typeList.join("、")}类型文件`);
        return false;
      }

      if (file.size > workField.maxSize * 1024 * 1024) {
        this.$message.error(`上传文件最大${workField.maxSize}M`);
        return false;
      }

      workField.loading = false;
      getToken(fileName)
        .then(({ data }) => {
          const { dir, filename, accessid, host, ...rest } = data;

          const formData = new FormData();
          Object.entries({
            name: filename,
            key: dir + filename,
            OSSAccessKeyId: accessid,
            success_action_status: "200", //让服务端返回200,不然，默认会返回204
            ...rest,
          }).forEach(([key, value]) => {
            formData.append(key, value);
          });

          formData.append("file", file);

          request({
            url: host,
            method: "post",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress(progressEvent) {
              workField.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
            timeout: 20 * 60 * 1000,
          })
            .then(({ data }) => {
              this.$message.success("上传成功");
              workField.fileName = file.name;
              this.form[`file${index}`] = data.fileUrl;
              workField.progress = 0;
            })
            .finally(() => {
              workField.loading = false;
              workField.disabled = true;
            });
        })
        .finally(() => {
          workField.loading = false;
          workField.disabled = true;
        });

      // const data = new FormData();
      // data.append("file", file);

      // workField.loading = true;
      // uploadWork(data)
      //   .then((data) => {
      //     // 防止闪烁，至少1.5s loading状态
      //     setTimeout(() => {
      //       this.$message.success("上传成功");
      //       workField.loading = false;
      //       workField.fileName = file.name;
      //       this.form[`file${index}`] = data.msg;
      //     }, 1000);
      //   })
      //   .catch(() => {
      //     workField.loading = false;
      //   });

      return false;
    },
    onSave() {
      this.$refs.uploadFormRef.validate(async (res) => {
        if (!res) return;

        const data = [];
        const { competitionId, form } = this;

        this.workFieldList.forEach(
          ({ id, title, isRequired, sort, fileName }, index) => {
            data.push({
              id,
              competitionId,
              title,
              isRequired,
              sort,
              fileName,
              fileUrl: form[`file${index}`],
            });
          }
        );

        saveWork({
          workFieldList: data,
          competitionId,
          workType: form.workType,
        }).then(() => {
          this.$message.success("提交成功");
          this.getWorkInfo();
        });
      });
    },
    onDelete(index, workField) {
      this.form[`file${index}`] = "";
      workField.fileName = "";
      workField.disabled = false;
    },
    //赛事详情接口
    getCompetitionDetail() {
      let params = {
        competitionId: this.$route.query.competitionId,
      };
      this.fullscreenLoading = true;
      getCompetitionDetail(params)
        .then((res) => {
          this.fullscreenLoading = false;
          this.competition = res.data.competition;
          sessionStorage.setItem(
            "competition",
            JSON.stringify(res.data.competition)
          );
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.work-upload {
  font-size: 20px;
  font-weight: 600;
  color: #07d9c8;
  line-height: 36px;
  background: #171f30;
  overflow: hidden;
}

::v-deep .el-input__inner {
  border-radius: 4px;
  border: 1px solid #e9ecf2;
  background: none;
  color: #fff;
}
::v-deep .el-form-item {
  margin-bottom: 30px;
}
::v-deep .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}

::v-deep .el-form-item__content {
  color: #ffffff;
}

.form {
  padding: 54px 370px 0 100px;
}
.title {
  display: flex;
  align-items: center;
}
.title img {
  width: 42px;
}
.title .tit {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  margin-left: 24px;
}
.content {
  width: 1180px;
  background: url("../../assets/detail-bg.png");
  margin: 0 auto;
  background: #0a2b51;
  border-radius: 20px;
  margin-top: -80px;
  border: 1px solid #046bde;
  padding: 55px 54px 50px;
  margin-bottom: 150px;
  position: relative;
}

.intro {
  display: flex;
  justify-content: center;
  margin: 54px auto 0;
  width: 800px;
}

.intro-p {
  padding: 13px 20px;
  background-color: #e6f2ff;
  border-radius: 4px;
  color: #046bde;
}

.close-btn:hover {
  background: rgba(250, 250, 250, 0.5);
}

.download-btn {
  color: red;
  margin-left: 15px;
}

.download-btn:hover {
  text-decoration: underline;
}

.file-item {
  display: flex;
  align-items: center;
}

.text-overflow {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
